import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    useEffect,
    useId,
    useMemo,
    useRef,
    useState,
} from 'react';

import {
    useClickOutside,
} from 'tools/hooks';

import {
    ErrorMessage,
} from 'components/other';

import arrowImage from './media/arrow.svg';

import styles from './MultiSelectInput.module.scss';

const MultiSelectInput: FC<IProps> = (props) => {
    const [value, setValue] = useState(props.value);
    const [isOpen, setIsOpen] = useState(false);

    const id = useId();

    const containerRef = useRef<HTMLDivElement>(null);

    const formattedValue = useMemo(() => {
        return value
            .map((valueItem) => props.formatValueItem?.(valueItem) ?? valueItem)
            .join(', ');
    }, [value]);

    const onClickValueItem = (valueItem: string) => {
        const newValue = value.includes(valueItem) ?
            value.filter((currentValueItem) => currentValueItem !== valueItem) :
            [...value, valueItem];

        setValue(newValue);
    };

    useClickOutside(containerRef, () => {
        setIsOpen(false);
    });
    useEffect(() => {
        setValue(props.value);
    }, [props.value]);
    useEffect(() => {
        if (isOpen) {
            return;
        }

        props.onChangeValue?.(value);
    }, [isOpen]);

    return (
        <div
            ref={containerRef}
            className={
                classNames(styles.multiSelectInput, props.className, {
                    [styles.isSmall]: props.size === 'small',
                    [styles.isOpen]: isOpen,
                    [styles.isDisabled]: props.isDisabled,
                    [styles.isError]: props.isError,
                })
            }
        >
            {
                props.label &&
                <label
                    htmlFor={id}
                    className={styles.label}
                >
                    {props.label}
                </label>
            }
            <div
                id={id}
                className={styles.value}
                onClick={() => setIsOpen(!isOpen)}
            >
                {formattedValue || '-'}
                <img
                    className={styles.arrowImage}
                    src={arrowImage}
                    alt={''}
                />
            </div>
            {
                isOpen && !props.isDisabled &&
                <div className={styles.options}>
                    {
                        props.values.map(
                            (valueItem) =>
                                <div
                                    key={valueItem}
                                    className={
                                        classNames(styles.option, {
                                            [styles.isActiveOption]: value.includes(valueItem),
                                        })
                                    }
                                    onClick={() => onClickValueItem(valueItem)}
                                >
                                    {props.formatValueItem?.(valueItem) ?? valueItem}
                                </div>
                        )
                    }
                </div>
            }
            <ErrorMessage
                className={styles.errorMessage}
                size={props.size}
                text={props.errorMessage ?? ''}
            />
        </div>
    );
};

export default MultiSelectInput;
